function Policy() {
    return (
        <div className="container mt-5">
            <h1>Privacy Policy</h1>
            <p>
                Privacy Policy
This website uses Google Analytics to collect anonymous data about visitor traffic, including pages visited and time spent on site. This information is used solely to understand how the site is being used and to improve the user experience.
No personal data is collected or stored. IP addresses are anonymised.
You can opt out of Google Analytics tracking at any time by using the Google Analytics Opt-out Browser Add-on.
For any questions, contact: maxtera87@gmail.com
</p>
        </div>
    );
    
}

export default Policy;